/*
registration: {
  email,
  firstName,
  lastName,
  password
}
*/
export default function signUpAsync(registration) {
  return $.post(
    '/api/v1/registrations',
    {
      registration: {
        email: registration.email,
        first_name: registration.firstName,
        last_name: registration.lastName,
        password: registration.password,
      },
    },
  );
}
